import { useMemo } from 'react';

import { getConditionDisplayName } from '../../config/skinConditionDisplayNames';
import { normalizeConditionName } from '../../utils/skinConditionNormalization';
import { buildDetailedConcernItems } from '../../utils/buildDetailedConcernItems';
import { sanitizeText } from '../../utils/sanitizeContent';
import { useSegmentation } from './SegmentationRenderer';

function replaceScoreMentions(text) {
  if (!text || typeof text !== 'string') return text;
  return text
    .replace(/\bscore[s]?\s*(of\s*)?(\d{1,3})\s*%?/gi, (_, __, n) => {
      const val = Number(n);
      if (val <= 39) return 'critical concern';
      if (val <= 59) return 'high concern';
      if (val <= 74) return 'moderate concern';
      if (val <= 89) return 'mild concern';
      return 'healthy range';
    });
}

const DeepDiveSection = ({ report }) => {
  const segmentation = useSegmentation();
  const deepDive = useMemo(
    () => report?.ai_report?.deep_dive || {},
    [report?.ai_report?.deep_dive],
  );

  const items = useMemo(
    () => buildDetailedConcernItems(report, segmentation),
    [report, segmentation],
  );

  const lines = useMemo(() => items
    .filter((item) => Number(item.score) < 75)
    .map((item) => {
      const label = getConditionDisplayName(item.class_name);
      const descriptionKey = Object.keys(deepDive || {}).find((key) => {
        if (!key) return false;
        return normalizeConditionName(key) === normalizeConditionName(item.class_name);
      });
      const aiDescription = descriptionKey ? deepDive[descriptionKey] : null;
      if (typeof aiDescription !== 'string' || !aiDescription.trim()) return null;
      return `${label}: ${sanitizeText(replaceScoreMentions(aiDescription.trim()))}`;
    })
    .filter(Boolean), [items, deepDive]);

  if (!lines.length) return null;

  return (
    <div className="skin-routine-section-block skin-routine-analysis-panel">
      <div className="skin-routine-section-heading-with-info">
        <h2 className="skin-routine-section-heading">Analysis Deep Dive</h2>
      </div>
      <ul className="skin-routine-analysis-lines">
        {lines.map((line, idx) => (
          <li key={`deep-dive-${idx}`}>{line}</li>
        ))}
      </ul>
    </div>
  );
};

export default DeepDiveSection;
